export default __webpack_public_path__ + "961017678b11376e9800fb8ea2c14520.svg";